
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

const Bitcoin = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-[#F1F0FB] to-white">
      <Header />
      <div className="container mx-auto px-4 py-12">
        <div className="mb-8">
          <Link to="/knowledge-hub/basics">
            <Button variant="ghost" className="flex items-center gap-2 hover:bg-[#9b87f5]/10 hover:text-[#9b87f5]">
              <ArrowLeft className="h-4 w-4" />
              Back to Crypto Basics
            </Button>
          </Link>
        </div>

        <article className="prose prose-slate lg:prose-lg max-w-4xl mx-auto bg-white rounded-2xl shadow-lg p-8 md:p-12">
          <h1 className="text-4xl md:text-5xl font-bold mb-8 text-[#4A607B] text-center !mt-0">
            Bitcoin: The First Decentralized Digital Currency
          </h1>

          <p className="text-lg text-gray-700 mb-8 text-center max-w-3xl mx-auto">
            Bitcoin, launched in 2009, revolutionized the financial world by introducing the first decentralized cryptocurrency, paving the way for a new era of digital finance.
          </p>

          <div className="space-y-12">
            <section>
              <h2 className="text-2xl font-semibold text-[#4A607B] mb-4">What is Bitcoin?</h2>
              <p className="text-gray-700">
                Bitcoin is a decentralized digital currency that operates without a central authority or banks managing transactions. The network is peer-to-peer, and transactions take place directly between users.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-[#4A607B] mb-4">Key Features</h2>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li>Decentralized: No central authority controls Bitcoin</li>
                <li>Limited Supply: Only 21 million bitcoins will ever exist</li>
                <li>Transparent: All transactions are recorded on a public ledger</li>
                <li>Secure: Protected by advanced cryptography</li>
                <li>Global: Accessible to anyone with internet access</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-[#4A607B] mb-4">How Bitcoin Works</h2>
              <p className="text-gray-700">
                Bitcoin transactions are verified by network nodes through cryptography and recorded on a public distributed ledger called a blockchain. Mining adds new blocks to the chain while releasing new bitcoins into circulation.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-[#4A607B] mb-4">Uses of Bitcoin</h2>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li>Digital Payment: For online purchases and transfers</li>
                <li>Store of Value: As a long-term investment</li>
                <li>International Remittance: For cross-border money transfers</li>
                <li>Financial Freedom: Access to financial services for the unbanked</li>
              </ul>
            </section>
          </div>
        </article>
      </div>
      <Footer />
    </div>
  );
};

export default Bitcoin;
